import { render, staticRenderFns } from "./selectSample.vue?vue&type=template&id=36f47370&scoped=true"
import script from "./selectSample.vue?vue&type=script&lang=js"
export * from "./selectSample.vue?vue&type=script&lang=js"
import style0 from "./selectSample.vue?vue&type=style&index=0&id=36f47370&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f47370",
  null
  
)

export default component.exports